import DepartmentRoot from '../../containers/Department/DepartmentRoot';

function Department() {
  return <DepartmentRoot />;
}

export default Department;
